import { useState } from 'react';

export default function useTaxInvoiceDetailManage() {
    const [isOpenTaxInvoiceModal, setIsOpenTaxInvoiceModal] = useState(false);

    return {
        isOpenTaxInvoiceModal,
        setIsOpenTaxInvoiceModal
    };
}
